import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from "../../services/authentication.service";
import {OrganizationTreeSelect} from "../../dip/organization-tree-select";
import {Organization} from "../../models/organization";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-distributor',
  templateUrl: './distributor.component.html'
})
export class DistributorComponent implements OnInit {
  distributor: Organization = null;
  detailsTitle: string = this.translate.instant('distributor.details.form_title');

  constructor(private authenticationService: AuthenticationService, private organizationTreeSelect: OrganizationTreeSelect, private translate: TranslateService) { }

  ngOnInit(): void {
    this.setDistributor();
    this.organizationTreeSelect.organizationLoadedEvent$.subscribe(() => {
      this.setDistributor();
    });
  }

  setDistributor() {
    this.distributor = null;
    if (this.authenticationService.currentUserValue.distributor) {
      this.distributor = this.authenticationService.currentUserValue.distributor;
    } else if (this.organizationTreeSelect.distributor && this.organizationTreeSelect.distributor.id !== -1) {
      this.distributor = this.organizationTreeSelect.distributor;
    }
  }
}
